import React from 'react';
import { Modal, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PDFModalViewer from '../utils/PDFModalViewer';

const ModalPDF = ({ open, handleClose, pdfOriginal }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: "0px",
        left: "0px",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1300,
      }}>
        <Box sx={{
          height: "85vh",
          width: { xs: "90%", md:"80%", lg: "45%"},
          alignSelf: "center",
          position: 'absolute',
          top:"50%",
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}>

          <Box sx={{
            width: "100%",
            overflow: "hidden",
            borderRadius: "20px",
            border: "6px solid #000079"
          }}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: "-35px",
                right: "2px",
                float: "right",
                color: "#ffffff",
                backgroundColor: "#D6001C",
                padding: "8px",
                borderRadius: "50%",
                overflow: "visible",
                transition: '0.3s',
                zIndex:"99999",
                '&:hover': {
                  bgcolor: 'secondary.main',
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {/* <Box>
              {pdfOriginal && <PDFModalViewer fileUrl={pdfOriginal} />}
            </Box> */}

            {/* <Box>
              {pdfOriginal ? (
                <PDFModalViewer fileUrl={pdfOriginal} />
              ) : (
                <Typography 
                  variant="body1" 
                  sx={{ 
                    //color: primary.deep, 
                    fontWeight: 'bold',
                    mt: 2 
                  }}
                >
                  Lo sentimos, el documento informativo no está disponible en este momento.
                </Typography>
              )}
            </Box>  */}

            <Box>
              {pdfOriginal ? (
                <PDFModalViewer fileUrl={pdfOriginal} />
              ) : (
                <Box
                  sx={{
                    //mt: 3,
                    p: { xs: 3, sm: 4 },
                    backgroundColor: '#fff',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    borderRadius: 3,
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minHeight: { xs: 180, sm: 220 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      backgroundColor: 'grey.100',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2,
                    }}
                  >
                    <DescriptionOutlinedIcon
                      sx={{
                        fontSize: 34,
                        color: 'grey.500',
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: 'grey.800',
                      mb: 1,
                    }}
                  >
                    Documento no disponible
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      color: 'grey.600',
                      maxWidth: 500,
                      lineHeight: 1.6,
                    }}
                  >
                    Lo sentimos, el documento informativo no está disponible
                    en este momento. Por favor, intenta nuevamente más tarde.
                  </Typography>
                </Box>
              )}
            </Box>

          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalPDF;